

setTimeout(function(){
  if($('.ls-notification').hasClass('ls-notification-link')){
      console.log("matched");
    $('.mini-cart-trigger').trigger('click');
  }
},1500);







$(document).on('click','.custom-icon-clk a',function(e){
  e.preventDefault();
  $('.mini-cart-trigger').trigger('click')
});

$(document).on('click','.modal-cart-remove',function(e){
          e.preventDefault();
         $('.mini-cart-trigger').trigger('click');
      });  


setTimeout(function() {
   $(".remove-product").removeAttr("target");
    
$('#find_your_size').html('');
  $.ajax({
   url: "/collections/all-bras/?view=custom-size-filter",
    type: "GET", //send it through get method
    async: true,
    success: function(response) {
    // var modelHtml = $('#collection-size-data',response).html();
    // console.log(response);
           $('#find_your_size').html("<option value='' selected='selected' disabled='disabled'>Bra Size</option>"+response);
        return false;
       },
    error: function(xhr) {
      //Do Something to handle error
    }
  });


$('#find_your_style').html('');
  $.ajax({
   url: "/pages/style-filter/?view=custom-style-filter",
    type: "GET", //send it through get method
    async: true,
    success: function(response) {
      //  var $content = $(response).find('#custom-style-filter').html();
      // console.log($content);
      //   console.log(response);
    // var modelHtml = $('#custom-style-filter',response).html();
    // console.log(modelHtml);
      $('#find_your_style').html("<option value='' selected='selected' disabled='disabled'>Find Your Style</option>"+response);
        return false;
       },
    error: function(xhr) {
      //Do Something to handle error
    }
  });

  },1000);



 //only add A-Z value not numaric validations
  $("#cup_size").on("keypress keyup blur",function (event) { 

 $(this).val($(this).val().replace(/[^a-zA-Z ]/, ""));

if (!((event.charCode > 64 && 
    event.charCode < 91) || event.charCode ==32 || (event.charCode > 96 && 
      event.charCode < 123))) {
      event.preventDefault();
    }
 });
  

 
$('body').on('click', '#btnFindSize', function(e) {
  e.preventDefault();
  var size = $("#find_your_size").val();
  if(size == '' && size == undefined){
    alert("Please select required field!!");
    return false;
  }
 var bandsize =  $("#find_your_size").find(':selected').attr('data-band');
 var cupsize =   $("#find_your_size").find(':selected').attr('data-cup');
  bandsize = bandsize.replace(" ","+");
  cupsize = cupsize.replace(" ","+");
  window.location.href = "/collections/all-bras/?gf_25762="+bandsize+"&gf_25763="+cupsize;
    //code
});

// enter event disable
$('.popup-form').on('keyup keypress', function(e) {
  var keyCode = e.keyCode || e.which;
  if (keyCode === 13) { 
    e.preventDefault();
    return false;
  }
});
$('body').on('click', '#btnFindStyle', function(e) {
    e.preventDefault();
  var style = $("#find_your_style").val();
  if(style == '' && style == undefined){
    alert("Please select required field!!");
    return false;
  }
   style = style.replace(" ","+");
  window.location.href = "/collections/all-bras/?gf_25435="+style;
    //code
});
 
$(".btn-trigger-modal").click(function(e){
e.preventDefault();
 var href = $(this).attr("data-target");  
$(href).attr("style","display:block !important;");

     $('html, body').animate({
        scrollTop: $("#top-bar").offset().top
    }, 800);
  
   $(".size-sections").attr("style","display:none !important;");
   var $slider = $('.custom_popup:visible .cstm_slider');
  var $progressBar = $('.custom_popup:visible  .progress');
  var $progressBarLabel = $( '.custom_popup:visible .slider__label' );
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
      
  });
  if($(href +" .cstm_slider").hasClass("slick-initialized")){
    $(href +" .cstm_slider").slick('destroy');
  }
  //console.log(href);
$(href +' .cstm_slider').slick({
  dots: false,
  infinite: false,
  slidesToShow: 1,
  adaptiveHeight: false,
draggable: false,
 swipe: false,
 touchMove: false,
responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
});
  
$('body').on('click', '.cstm_close', function(e) {
e.preventDefault();
  var href = $(this).attr("data-target");  
  $(href).attr("style","display:none !important");
   $(".size-sections").attr("style","display:block !important;");
});
$('body').on('click', '.tab-val-data a', function(e) {
 var index = $(this).attr("href"); 
  //console.log(index);
var imgData =  $(index).find(".tab-img-data").html();
  
 $(index).parents().parents(".tab--block").find(".img-data-tabs-main").html(imgData);
  var id=$(index).find(".form-data-chk").attr("name");
   $("input[name="+id+"]").removeAttr("checked");
  //console.log($("input[name="+id+"]").length);
  $(index).find(".form-data-chk").attr("checked","checked");
});

var new_array = [
   ["1111", "1", "0"],["1113", "1", "1"],["1112", "1", "0"],["1121", "1", "1"],["1123", "1", "-1"],
   ["1122", "1", "-1"],["1131", "1", "1"],["1133", "1", "-1"],["1132", "1", "-1"],["1211", "1", "1"],
   ["1212", "1", "1"],["1213", "1", "1"],["1221", "1", "1"],["1222", "1", "0"],["1223", "1", "0"],
   ["1231", "1", "0"],["1232", "1", "0"],["1233", "1", "0"],["1311", "1", "0"],["1312", "1", "0"],
   ["1313", "1", "0"],["1321", "1", "0"],["1322", "1", "0"],["1323", "1", "0"],["1331", "1", "0"],
   ["1332", "1", "0"],["1333", "1", "0"],["1411", "1", "0"],["1412", "1", "0"],["1413", "1", "0"],
   ["1421", "1", "0"],["1422", "1", "-1"],["1423", "1", "-1"],["1431", "1", "0"],["1432", "1", "-1"],
   ["1433", "1", "-1"],["2111", "-1", "1"],["2112", "-1", "1"],["2113", "-1", "0"],["2121", "-1", "1"],
   ["2122", "-1", "1"],["2123", "-1", "1"],["2131", "-1", "1"],["2132", "-1", "1"],["2133", "-1", "1"],
   ["2211", "-1", "2"],["2212", "-1", "1"],["2213", "-1", "1"],["2221", "-1", "1"],["2222", "-1", "1"],
   ["2223", "-1", "1"],["2231", "-1", "1"],["2232", "-1", "1"],["2233", "-1", "1"],["2311", "-1", "2"],
   ["2312", "-1", "2"],["2313", "-1", "2"],["2321", "-1", "2"],["2322", "-1", "2"],["2323", "-1", "2"],
   ["2331", "-1", "2"],["2332", "-1", "2"],["2333", "-1", "2"],["2411", "-1", "1"],["2412", "-1", "2"],
   ["2413", "-1", "1"],["2421", "-1", "1"],["2422", "-1", "1"],["2423", "-1", "1"],["2431", "-1", "2"],
   ["2432", "-1", "1"],["2433", "-1", "1"],["3111", "0", "1"],["3112", "0", "1"],["3113", "0", "1"],
   ["3121", "1", "0"],["3122", "1", "-1"],["3123", "1", "0"],["3131", "0", "1"],["3132", "1", "-1"],
   ["3133", "0", "0"],["3211", "0", "1"],["3212", "0", "1"],["3213", "0", "1"],["3221", "1", "0"],
   ["3222", "1", "-1"],["3223", "1", "-1"],["3231", "0", "1"],["3232", "0", "1"],["3233", "0", "1"],
   ["3311", "0", "1"],["3312", "1", "0"],["3313", "1", "1"],["3321", "1", "0"],["3322", "1", "0"],
   ["3323", "0", "1"],["3331", "0", "1"],["3332", "1", "0"],["3333", "0", "0"],["3411", "0", "1"],
   ["3412", "1", "1"],["3413", "0", "1"],["3421", "1", "-1"],["3422", "1", "-1"],["3423", "1", "-1"],
   ["3431", "0", "1"],["3432", "1", "-1"],["3433", "0", "0"]
];



    //form
var slider = document.getElementById("par2");
var output = document.getElementById("bandout");
var slider2 = document.getElementById("par1");
var output2 = document.getElementById("bustout");
var res = document.getElementById("res");
var csresus = document.getElementById("csresus");
var csresuk = document.getElementById("csresuk");
var csdiv = document.getElementById("cs");
output.innerHTML = slider.value;
output2.innerHTML = slider2.value;


slider.oninput = function() {
  output.innerHTML = this.value;

  if(this.value >= slider2.value) {
	slider2.value = Number(this.value)+1;
	output2.innerHTML = Number(this.value)+1;
  }
//   console.log(this.value + " - " + slider2.value);
}
slider2.oninput = function() {
  output2.innerHTML = this.value;
}

var x = document.getElementById("recsize");
var y = document.getElementById("divres");
var z = document.getElementById("nores");

function NewCalcularTotal() {

	// console.log(x);
	if (x.style.display == "none") {
		x.style.display = "block";
	}

	if(slider.value % 2 === 0 ) {
      var slide_val1 = slider.value;
	  var slide_val2 = slider.value;
		res.innerHTML=slider.value;
		res2.innerHTML=slider.value;
	} else {
       var slide_val1 = Number(slider.value)+1;
	  var slide_val2 = Number(slider.value)+1;
	
		res.innerHTML=Number(slider.value)+1;
		res2.innerHTML=Number(slider.value)+1;
	}

	$cs = Number(slider2.value) - Number(slider.value);

	switch ($cs) {
		case 1:	$csreus = "A"; $csreuk = "A";break;
		case 2:	$csreus = "B"; $csreuk = "B";break;
		case 3:	$csreus = "C"; $csreuk = "C";break;
		case 4:	$csreus = "D"; $csreuk = "D";break;
		case 5:	$csreus = "DD"; $csreuk = "DD";break;
		case 6:	$csreus = "DDD"; $csreuk = "E";break;
		case 7:	$csreus = "G"; $csreuk = "F";break;
		case 8:	$csreus = "H"; $csreuk = "FF";break;
		case 9:
			
			if(Number(slider.value) == 38 || Number(slider.value) == 40) {
				$csreus = "J"; $csreuk = "G";
			} else {
				$csreus = "I"; $csreuk = "G";
			}
			break;
		case 10:	
			if(Number(slider.value) == 38 || Number(slider.value) == 40) {
				$csreus = "JJ"; $csreuk = "GG";
			} else {
				$csreus = "J"; $csreuk = "GG";
			}
			break;
		case 11:	$csreus = "K"; $csreuk = "H";break;
		case 12:	$csreus = "L"; $csreuk = "HH";break;
		case 13:	$csreus = "M"; $csreuk = "J";break;
		case 14:	$csreus = "N"; $csreuk = "JJ";break;
		case 15:	$csreus = "O"; $csreuk = "K";break;
		default: $csreus = ""; $csreuk ="";break;
	}
	if ($csreus =="" && $csreuk =="") {
		y.style.display = "none";
		z.style.display = "block";
        $("button#next-show-results").hide();
	} else {
		y.style.display = "block";
		z.style.display = "none";
        $("button#next-show-results").show();

	}

	csresus.innerHTML = $csreus;
	csresuk.innerHTML = $csreuk;
//	alert($cs);
//	csdiv.innerHTML = $cs;
    var rr_result_heading = "With a measuring tape";
  //console.log(rr_result_heading)
   $(".parfait_result_1_heading").val(rr_result_heading);
 var rr_result = "US "+slide_val1+""+$csreus +" - UK "+ slide_val2+""+$csreuk;
  $(".parfait_result_1").val(rr_result);
  
   var rr_result_url_heading = "With a measuring tape url:";
   //console.log(rr_result_url_heading);
   //$(".parfait_result_1_url").val(rr_result_url_heading);

   var bandsize = $('.custom_popup:visible .popup-form').find("span#res").html();
   var cupsizeus = $('.custom_popup:visible .popup-form').find("#csresus").html();
   var cupsizeuk = $('.custom_popup:visible .popup-form').find("#csresuk").html();
   bandsize = $.trim(bandsize);
   cupsizeus = "US+"+$.trim(cupsizeus)+"+-+";
   cupsizeuk = "UK+"+$.trim(cupsizeuk);
   var cupsize = cupsizeus+""+cupsizeuk;
   bandsize = bandsize.replace(" ","+");
   cupsize = cupsize.replace(" ","+");
   var url = "https://parfaitlingerie.com/collections/all-bras/?gf_25762="+bandsize+"&gf_25763="+cupsize
   $(".parfait_result_1_url").val(url);
 console.log($(".parfait_result_1_url").val());
//yotpo_data();
  
}

function ResetTotal() { 
	res.innerHTML=30;
	res2.innerHTML=30;
	slider.value = 30;
	slider2.value = 31;
	output.innerHTML = 30;
	output2.innerHTML = 31;
	csresus.innerHTML = "";
	csresuk.innerHTML = "";
	x.style.display = "none";
}

function validationMsg($this){
  /************Calculator validation*********************/
  if($this.hasClass("range_btn")){
    var par1 = parseInt($("#par1").val());
    var par2 = parseInt($("#par2").val());
    //console.log(par1+"==="+par2);
    if(par1 <=30 && par2 <=30){
      console.log($this.parents(".button_type").find(".error-message").length);
      $this.parents(".button_type").find(".error-message").html("Please select the values from the calculator");
      return false;
    }else{
      $this.parents(".button_type").find(".error-message").html("");
   }    
  }
  
   /************Email validation*********************/ 
  if($this.hasClass("cal_btn_without")){
    var email = $this.parents().parents(".email-main-div").find(".custom_email").val();
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
     if (email == '') {
      $this.parents(".button_type").find(".error-message").html("Please enter the correct email id.");
    return false;
    }else if (!emailReg.test(email)) {
      $this.parents(".button_type").find(".error-message").html("Please enter the correct email id.");
    return false;
    } else {
      $this.parents(".button_type").find(".error-message").html(""); 
    }
  }

  if($this.hasClass("last-tabs-calc")){
    getCalcResult();
  }
  /*************Band size & cup size validation************************/
  if($this.hasClass("btn-band-cup-size")){
    var bandsize = $.trim($this.parents().parents(".size-main-div").find(".cst_band_size").val());
    var cupsize = $.trim($this.parents().parents(".size-main-div").find(".cst_cup_size").val());
    var letters = /^[A-Za-z]+$/;
    if(bandsize > 27 && bandsize < 29){
     //do nothing
    }
    else if(bandsize > 29 && bandsize < 31){ 
    }
    else if(bandsize > 31 && bandsize < 33){ 
    }
      else if(bandsize > 33 && bandsize < 35){ 
    }
        else if(bandsize > 35 && bandsize < 37){ 
    }
          else if(bandsize > 37 && bandsize < 39){ 
    }
            else if(bandsize > 39 && bandsize < 41){ 
    }
              else if(bandsize > 41 && bandsize < 43){ 
    }
                else if(bandsize > 43 && bandsize < 45){ 
    }
    else{
      $this.parents(".button_type").find(".error-message").html("Band Sizes are only available between 28,30,32,34,36,38,40,42 and 44.");
      return false;
    }
     
    if(bandsize == '' || bandsize == "NaN" || cupsize == '' || cupsize == null ){
      $this.parents(".button_type").find(".error-message").html("Band Size/Cup Size can't be empty.");
      return false;
     }else if(isNaN(bandsize)) {
      $this.parents(".button_type").find(".error-message").html("Band Size can only be numeric.");
      return false;
    }else if(!cupsize.match(letters)) {
     $this.parents(".button_type").find(".error-message").html("Cup Size can only be alphabets.");
      return false;
    } else{
       $this.parents(".button_type").find(".error-message").html(""); 
    }

   if(cupsize == 'A' || cupsize == 'B' ||  cupsize == 'C' ||  cupsize == 'D' ||  cupsize == 'DD' || cupsize == 'DDD' || cupsize == 'E' || cupsize == 'F' || cupsize == 'G' || cupsize == 'H' || cupsize == 'I' || cupsize == 'J' || cupsize == 'K' || cupsize == 'L' || cupsize == 'M' || cupsize == 'N' || cupsize == 'O' || cupsize == 'a' || cupsize == 'b' ||  cupsize == 'c' ||  cupsize == 'd' ||  cupsize == 'dd' || cupsize == 'ddd' || cupsize == 'e' || cupsize == 'f' || cupsize == 'g' || cupsize == 'h' || cupsize == 'i' || cupsize == 'j' || cupsize == 'k' || cupsize == 'l' || cupsize == 'm' || cupsize == 'n' || cupsize == 'o'){
      
    }else{
        $this.parents(".button_type").find(".error-message").html("Only US cup sizes available like A,B,C,D,DD,DDD,E,F,G,H,I,J,K,L,M,N,O");
      return false;
    }
  }
  
  return true;
}
$(document).on('click','.btn-next',function(){
  var $this = $(this);
  var validation = validationMsg($this);
  if(validation == false){
    return false;
  }
  
$('.size-pause-video').trigger( "click" );
          
var slickIndex  = $(".custom_popup:visible").find('.slick-current').attr("data-slick-index");  
  var index = parseInt(slickIndex) + 1;
           
  $('.slick-slider').slick("slickGoTo",index);
});
$(document).on('click','.btn-prev',function(){
var slickIndex  = $(".custom_popup:visible").find('.slick-current').attr("data-slick-index");  
  var index = parseInt(slickIndex) - 1;
           
  $('.slick-slider').slick("slickGoTo",index);
  
});

//range slide validation 1st popup
$(document).on('change','#par2',function(){
var minval = parseInt($("#par2").attr("min"));
var bandout = parseInt($("#bandout").text());
var minval2 = parseInt($("#par1").attr("min"));
var bustout = parseInt($("#bustout").text());

var res = 0;
if(minval != bandout){
  res++;
}
if(minval2 != bustout){
  res++;
}

    
});
$(document).on('change','#par1',function(){
var minval = parseInt($("#par2").attr("min"));
var bandout = parseInt($("#bandout").text());
var minval2 = parseInt($("#par1").attr("min"));
var bustout = parseInt($("#bustout").text());

var res = 0;
if(minval != bandout){
  res++;
}
if(minval2 != bustout){
  res++;
}
 
    
});
$("#par1").trigger("change");


//get results


$('body').on('click', '#next-show-results', function(e) {
 e.preventDefault();
  var bandsize = $("span#res").html();
  var cupsizeus = $("#csresus").html();
  var cupsizeuk = $("#csresuk").html();
    bandsize = $.trim(bandsize);
    cupsizeus = "US+"+$.trim(cupsizeus)+"+-+";
    cupsizeuk = "UK+"+$.trim(cupsizeuk);
  var cupsize = cupsizeus+""+cupsizeuk;
  bandsize = bandsize.replace(" ","+");
  cupsize = cupsize.replace(" ","+");
  window.location.href = "/collections/all-bras/?gf_25762="+bandsize+"&gf_25763="+cupsize;
 // yotpo_data("submit");
   //$("#smsbump-form-373101 button[type='primary']").trigger("click");
 //setTimeout(function(){ window.location.href = "/collections/all-bras/?gf_25762="+bandsize+"&gf_25763="+cupsize; },100);
});
$('body').on('click', '#next-get-result', function(e) {
 e.preventDefault();
  var bandsize = $("span#res1").html();
  var cupsizeus = $("#csresus1").html();
  var cupsizeuk = $("#csresuk1").html();
    bandsize = $.trim(bandsize);
    cupsizeus = "US+"+$.trim(cupsizeus)+"+-+";
    cupsizeuk = "UK+"+$.trim(cupsizeuk);
  var cupsize = cupsizeus+""+cupsizeuk;
  bandsize = bandsize.replace(" ","+");
  cupsize = cupsize.replace(" ","+");
  window.location.href = "/collections/all-bras/?gf_25762="+bandsize+"&gf_25763="+cupsize;
 // yotpo_data("submit");
//  $("#smsbump-form-373101 button[type='primary']").trigger("click");
 
 //setTimeout(function(){ window.location.href = "/collections/all-bras/?gf_25762="+bandsize+"&gf_25763="+cupsize; },100);
});

function getCalcResult(){
  var modal = $('.custom_popup:visible .popup-form').parents(".modal").attr("id");
 
  var form_id_klav = $('.custom_popup:visible .popup-form').attr("id");
  var data = $('.custom_popup:visible .popup-form').serialize();
  var email = $('.custom_popup:visible .popup-form').find("#email");
 
  if($('.custom_popup:visible .popup-form').find("#band_size").length == 0 && $('.custom_popup:visible .popup-form').find("#cup_size").length == 0){
    return false;
  }
 var Band_size = $('.custom_popup:visible .popup-form').find("#band_size").val();
  var cup_size = $('.custom_popup:visible .popup-form').find("#cup_size").val().toUpperCase();
   $('.custom_popup:visible .popup-form').find("#cup_size").val(cup_size);
  var i = 0;
  var combination = '';
  $( ".modal-split .form-data-chk" ).each(function( index ) {
    if($(this).prop("checked")==true){
      combination +=$(this).val();
      console.log(index+"==="+$(this).val());
      }
  });
var retlen = combination.split("");
  if(combination == '' && retlen.length <4 ){
    return false;
  }
  // console.log($('.combination').val());
  function search(nameKey, myArray) {
    for (let i = 0; i < myArray.length; i++) {
      if (myArray[i][0] === nameKey) {
        return myArray[i];
      }
    }
  }
 var new_array = [
      ["1111", "1", "0"],["1113", "1", "1"],["1112", "1", "0"],["1121", "1", "1"],["1123", "1", "-1"],
      ["1122", "1", "-1"],["1131", "1", "1"],["1133", "1", "-1"],["1132", "1", "-1"],["1211", "1", "1"],
      ["1212", "1", "1"],["1213", "1", "1"],["1221", "1", "1"],["1222", "1", "0"],["1223", "1", "0"],
      ["1231", "1", "0"],["1232", "1", "0"],["1233", "1", "0"],["1311", "1", "0"],["1312", "1", "0"],
      ["1313", "1", "0"],["1321", "1", "0"],["1322", "1", "0"],["1323", "1", "0"],["1331", "1", "0"],
      ["1332", "1", "0"],["1333", "1", "0"],["1411", "1", "0"],["1412", "1", "0"],["1413", "1", "0"],
      ["1421", "1", "0"],["1422", "1", "-1"],["1423", "1", "-1"],["1431", "1", "0"],["1432", "1", "-1"],
      ["1433", "1", "-1"],["2111", "-1", "1"],["2112", "-1", "1"],["2113", "-1", "0"],["2121", "-1", "1"],
      ["2122", "-1", "1"],["2123", "-1", "1"],["2131", "-1", "1"],["2132", "-1", "1"],["2133", "-1", "1"],
      ["2211", "-1", "2"],["2212", "-1", "1"],["2213", "-1", "1"],["2221", "-1", "1"],["2222", "-1", "1"],
      ["2223", "-1", "1"],["2231", "-1", "1"],["2232", "-1", "1"],["2233", "-1", "1"],["2311", "-1", "2"],
      ["2312", "-1", "2"],["2313", "-1", "2"],["2321", "-1", "2"],["2322", "-1", "2"],["2323", "-1", "2"],
      ["2331", "-1", "2"],["2332", "-1", "2"],["2333", "-1", "2"],["2411", "-1", "1"],["2412", "-1", "2"],
      ["2413", "-1", "1"],["2421", "-1", "1"],["2422", "-1", "1"],["2423", "-1", "1"],["2431", "-1", "2"],
      ["2432", "-1", "1"],["2433", "-1", "1"],["3111", "0", "1"],["3112", "0", "1"],["3113", "0", "1"],
      ["3121", "1", "0"],["3122", "1", "-1"],["3123", "1", "0"],["3131", "0", "1"],["3132", "1", "-1"],
      ["3133", "0", "0"],["3211", "0", "1"],["3212", "0", "1"],["3213", "0", "1"],["3221", "1", "0"],
      ["3222", "1", "-1"],["3223", "1", "-1"],["3231", "0", "1"],["3232", "0", "1"],["3233", "0", "1"],
      ["3311", "0", "1"],["3312", "1", "0"],["3313", "1", "1"],["3321", "1", "0"],["3322", "1", "0"],
      ["3323", "0", "1"],["3331", "0", "1"],["3332", "1", "0"],["3333", "0", "0"],["3411", "0", "1"],
      ["3412", "1", "1"],["3413", "0", "1"],["3421", "1", "-1"],["3422", "1", "-1"],["3423", "1", "-1"],
      ["3431", "0", "1"],["3432", "1", "-1"],["3433", "0", "0"]
   ];

  var new_arrayBand =["28", "30", "32", "34", "36", "38", "40", "42", "44"];

  var new_arrray_cup = [
      ["A" , "A"], ["B" , "B"], ["C" , "C"], ["D" , "D"], ["DD" , "DD"], ["DDD" , "E"], ["G" , "F"], ["H" , "FF"], ["I" , "G"], ["J" , "GG"], ["K" , "H"], ["L" , "HH"],
      ["M" , "J"], ["N" , "JJ"], ["O" , "K"]
  ];

  var new_arrray_cup_new = [                                                         
      ["A" , "A"], ["B" , "B"], ["C" , "C"], ["D" , "D"], ["E" , "DD"], ["F" , "E"], ["G" , "F"], ["H" , "FF"], ["I" , "G"], ["J" , "GG"], ["K" , "H"], ["L" , "HH"],
      ["M" , "J"], ["N" , "JJ"], ["O" , "K"]
  ];


  // ==================================================================================
 //alert(combination);
  const resultObject = search(combination, new_array);
  console.log(resultObject);
  if($(".developer_mode").length > 0){
  $(".developer_mode").html("Developer Mode<br>Customer Value : "+Band_size+" "+cup_size+"<br>Combination : "+combination+"<br/>Band Size : "+resultObject[1]+"<br/> Cup Size :"+resultObject[2]);
  }
// ============================================= Bust size==================
 
  const band_index = new_arrayBand.indexOf(Band_size)
    console.log(new_arrayBand[band_index+1]);
  
 // =============================================

 // ======================================== uk Size =========================
if(search(cup_size, new_arrray_cup) != undefined){
var resultObject3 = search(cup_size, new_arrray_cup);
  console.log('helo Friday');
  console.log(resultObject3);
   console.log(new_arrray_cup.indexOf(resultObject3));
      var final_cup_size =   new_arrray_cup.indexOf(resultObject3)
          // console.log(new_arrray_cup[final_cup_size][0]);
}else{
var resultObject3_new = search(cup_size, new_arrray_cup_new);
  console.log('helo Friday2');
   console.log(new_arrray_cup_new.indexOf(resultObject3_new));
      var final_cup_size =   new_arrray_cup_new.indexOf(resultObject3_new)
}
//=============================================

  if (resultObject[1] == 0 )  {
      $("#res1, #res3").text(new_arrayBand[band_index]);
     //$(".size_count").html("Congrats! you've done it!");
       $(".tab-result-main-div").find(".tab_result").show();
       $(".size_count").show();
      $(".nores").hide();
    //show the size btn
     $("#next-get-result").show();
  } else if (resultObject[1] == 1 ) {
    if(new_arrayBand[band_index + 1] == undefined){
       $(".tab-result-main-div").find(".tab_result").hide();
       $(".size_count").hide();
      $(".nores").show();
       //hide the size btn
       $("#next-get-result").hide();
    }else{
      $(".tab-result-main-div").find(".tab_result").show();
       $(".size_count").show();
      $(".nores").hide();
      //show the size btn
       $("#next-get-result").show();
      $("#res1 ,#res3").text(new_arrayBand[band_index + 1]);
    }

  }else {
    if(new_arrayBand[band_index - 1] == undefined){
      $(".tab-result-main-div").find(".tab_result").hide();
       $(".size_count").hide();
      $(".nores").show();
      //hide the size btn
       $("#next-get-result").hide();
    }else{
      $("#res1, #res3").text(new_arrayBand[band_index - 1]);
      $(".tab-result-main-div").find(".tab_result").show();
       $(".size_count").show();
      $(".nores").hide();
      //show the size btn
      $("#next-get-result").show();
  }
}
  if (resultObject[2] == 0 )  {
   $("#csresus1").text(new_arrray_cup[final_cup_size][0]);
   $("#csresuk1").text( new_arrray_cup[final_cup_size][1]);

  } else if (resultObject[2] == 1 ) {
    if(new_arrray_cup[final_cup_size +1] == undefined){
      $("#csresus1").text( new_arrray_cup[final_cup_size ][0]  );
      $("#csresuk1").text( new_arrray_cup[final_cup_size ][1] );
    }else{
     $("#csresus1").text( new_arrray_cup[final_cup_size +1][0]  );
   $("#csresuk1").text( new_arrray_cup[final_cup_size + 1][1] );
    }
  }else if (resultObject[2] == 2 ) {
    if(new_arrray_cup[final_cup_size + 2 ] == undefined){
      $("#csresus1").text( new_arrray_cup[final_cup_size  ][0]  );
      $("#csresuk1").text( new_arrray_cup[final_cup_size  ][1]  );
    }else{
      $("#csresus1").text( new_arrray_cup[final_cup_size + 2 ][0]  );
      $("#csresuk1").text( new_arrray_cup[final_cup_size + 2 ][1]  );
    }
  }else {   
    if(new_arrray_cup[final_cup_size - 1 ] == undefined){
      $("#csresus1").text( new_arrray_cup[final_cup_size  ][0]  );
      $("#csresuk1").text( new_arrray_cup[final_cup_size ][1]);
    }else{
      $("#csresus1").text( new_arrray_cup[final_cup_size - 1 ][0]  );
      $("#csresuk1").text( new_arrray_cup[final_cup_size - 1][1]);
    }
 
  }
  
  // ===================================================================================
 
   console.log("US" + $("#res1").text() + " " + $("#csresus1").text())
   console.log("Uk" + $("#res3").text() + " " + $("#csresuk1").text())
  var cobinput = $('.custom_popup:visible .popup-form').find('.combination').val(resultObject[0]);
  //console.log(cobinput)
  var rr_result_nn_heading = "Without a measuring tape";
  //console.log(rr_result_nn_heading)
  rr_result_nn_heading.replace(/(<([^>]+)>)/ig,"");
  $(".parfait-popup2").val(rr_result_nn_heading);
  var us_Size = $("#us_Size").val("US " + $("#res1").text() + "" + $("#csresus1").text());
  var uk_Size = $("#uk_Size").val("UK " + $("#res3").text() + "" + $("#csresuk1").text());
  
  var rr_result_nn = "US " + $("#res1").text() + "" + $("#csresus1").text() + " - UK " + $("#res3").text() + "" + $("#csresuk1").text();
  console.log(rr_result_nn);
  rr_result_nn.replace(/(<([^>]+)>)/ig,"");
 $(".parfait_result_1").val(rr_result_nn);
 $(".parfait_result_1_heading").val("Without Measuring Tape");

     var rr_result_url_2_heading = "Without a measuring tape url:";
   //console.log(rr_result_url_2_heading);
   //$(".parfait-result-url").val(rr_result_url_2_heading);
  
  var bandsize = $('.custom_popup:visible .popup-form').find("span#res1").html();
  var cupsizeus = $('.custom_popup:visible .popup-form').find("#csresus1").html();
  var cupsizeuk = $('.custom_popup:visible .popup-form').find("#csresuk1").html();
    bandsize = $.trim(bandsize);
    cupsizeus = "US+"+$.trim(cupsizeus)+"+-+";
    cupsizeuk = "UK+"+$.trim(cupsizeuk);
  var cupsize = cupsizeus+""+cupsizeuk;
  bandsize = bandsize.replace(" ","+");
  cupsize = cupsize.replace(" ","+");
var url_2 = "https://parfaitlingerie.com/collections/all-bras/?gf_25762="+bandsize+"&gf_25763="+cupsize;

$(".parfait_result_1_url").val(url_2);
console.log($(".parfait_result_1_url").val());
//yotpo_data();
}
$('body').on('submit', '.custom_popup:visible .popup-form', function(e) {
  e.preventDefault();
  
   //****script goes here*****/
  var slickIndex  = $(".custom_popup:visible").find('.slick-current').attr("data-slick-index");  
  var index = parseInt(slickIndex) + 1;           
  $('.slick-slider').slick("slickGoTo",index);
//yotpo_data();
    
  return false;
});
//************ slick progress******//

// function yotpo_data(type = "submit") {
//   /************ Yotpo Form results****************/
//   // $("#smsbump-form-373101 .cBcGnh").attr("style","z-index:1428749827849 !important");

//   var cstm_email_jtpl = $('.custom_popup:visible .popup-form').find(".email-main-div .custom_email").val();
//   var cstm_band_jtpl = $('.custom_popup:visible .popup-form').find(".cst_band_size").val();
//   cstm_band_jtpl = $.trim(cstm_band_jtpl);
//   var cstm_cup_jtpl = $('.custom_popup:visible .popup-form').find(".cst_cup_size").val();
//   cstm_cup_jtpl = $.trim(cstm_cup_jtpl).toLowerCase();
//   var popup_name_jtpl = $('.custom_popup:visible .popup-form').find(".parfait_result_1_heading").val();
//   popup_name_jtpl = $.trim(popup_name_jtpl).toLowerCase();
//   popup_name_jtpl = popup_name_jtpl.replaceAll(" ", "_");
//   popup_name_jtpl = popup_name_jtpl.replaceAll("without_", "without_a_");
//   var result_old = $('.custom_popup:visible .popup-form').find(".parfait_result_1").val();
//   console.log(result_old);
//   var results_jtpl = result_old;
//   if (result_old != undefined) {
//     results_jtpl = result_old.toLowerCase();
//     results_jtpl = results_jtpl.replaceAll(" ", "_");
//     results_jtpl = results_jtpl.replaceAll("-", "_");
//     results_jtpl = results_jtpl.replaceAll("__uk", "_uk");
//     results_jtpl = results_jtpl.replace(/__uk/g, "_uk");
//   }
//   console.log(cstm_band_jtpl + "===" + cstm_cup_jtpl + "====" + popup_name_jtpl + "======" + results_jtpl);

//   $("#smsbump-form-373101 .yotpo-smsbump-input__field.yotpo-smsbump-email-input__field").val(cstm_email_jtpl);
//   // $("#smsbump-form-373101 input[name='bandsize']").removeAttr("checked");
//   // $("#smsbump-form-373101 input[name='bandsize']").each(function(){

//   //    if($.trim($(this).val()) == $.trim(cstm_band_jtpl)){
//   // $(this).attr("checked","checked");
//   //   }
//   // });


// //   $("#smsbump-form-373101 input[name='bandsize']").prop("checked", false);
// // $("#smsbump-form-373101 input[name='bandsize']").each(function () {
// //   if ($.trim($(this).val()) == $.trim(cstm_band_jtpl)) {
// //     $(this).prop("checked", true);
// //   }
// // });

//   $("#smsbump-form-373101 input[name='bandsize']").removeAttr("checked");
//   $("#smsbump-form-373101 input[name='bandsize']").each(function () {
//     if ($.trim($(this).val()) == $.trim(cstm_band_jtpl)) {
//       console.log("YES.Result..." + $(this).val() + "===" + cstm_band_jtpl);
//       $(this).attr("checked", "checked");
//     }
//   });

  

//   // $("#smsbump-form-373101 input[name='cupsizeus']").removeAttr("checked");
//   //  $("#smsbump-form-373101 input[name='cupsizeus']").each(function(){
//   //  if($.trim($(this).val()) == $.trim(cstm_cup_jtpl)){
//   //     $(this).attr("checked","checked");
//   //   }
//   // });

//   $("#smsbump-form-373101 input[name='cupsizeus']").removeAttr("checked");
//   $("#smsbump-form-373101 input[name='cupsizeus']").each(function () {
//     if ($.trim($(this).val()) == $.trim(cstm_cup_jtpl)) {
//       console.log("YES.Result..." + $(this).val() + "===" + cstm_cup_jtpl);
//       $(this).attr("checked", "checked");
//     }
//   });

//   //  $("#smsbump-form-373101 input[name='parfait_popup']").removeAttr("checked");
//   // $("#smsbump-form-373101 input[name='parfait_popup']").each(function(){
//   //     console.log($(this).val()+"==="+$.trim(popup_name_jtpl));
//   //   if($.trim($(this).val()) == $.trim(popup_name_jtpl)){
//   //      $(this).attr("checked","checked");
//   //    }
//   //  });

//   $("#smsbump-form-373101 input[name='parfait_popup']").removeAttr("checked");
//   $("#smsbump-form-373101 input[name='parfait_popup']").each(function () {
//     if ($.trim($(this).val()) == $.trim(popup_name_jtpl)) {
//       console.log("YES.Result..." + $(this).val() + "===" + popup_name_jtpl);
//       $(this).attr("checked", "checked");
//     }
//   });


//   $("#smsbump-form-373101 input[name='parfait_results']").removeAttr("checked");
//   $("#smsbump-form-373101 input[name='parfait_results']").each(function () {
//     if ($.trim($(this).val()) == $.trim(results_jtpl)) {
//       console.log("YES.Result..." + $(this).val() + "===" + results_jtpl);
//       $(this).attr("checked", "checked");
//     }
//   });

//   const form = document.querySelector('form.sc-1absc7o-2.ieCKM');

//   form.querySelectorAll('input').forEach(input => {
//     console.log(input.value);
//     if ((input.type === 'checkbox' || input.type === 'radio')) {
//       console.log(input); console.log(input.checked);
//       if (input.checked) {
//         input.dispatchEvent(new Event('change', { bubbles: true }));
//       }
//     } else {
//       input.dispatchEvent(new Event('input', { bubbles: true }));
//       input.dispatchEvent(new Event('change', { bubbles: true }));
//     }
//   });


//   //if(type=="submit"){ 
//   setTimeout(function () {
//     // $("#smsbump-form-373101 .yotpo-smsbump-submit-button button").attr("type","submit");
//     $("#smsbump-form-373101 .yotpo-smsbump-submit-button button").trigger("click");
//     //  $("form.sc-1absc7o-2.ieCKM").submit();
//   }, 500);
//   return false;

//   // }

// }
$(document).on('click', '.size-play-video', function () {
  //currentPlayingTrack.play();
  $(this).parents(".playpause_btn").find('.size-pause-video').show();
  $(this).hide();
  $(this).parents().parents(".video-embed").find(".popup_vido").get(0).play();
});

$(document).on('click', '.size-pause-video', function () {
  //currentPlayingTrack.pause();
  $(this).hide();
  $(this).parents(".playpause_btn").find('.size-play-video').show();
  $(this).parents().parents(".video-embed").find(".popup_vido").get(0).pause();
});

//****hide Shop button if No suggested size available*****//
$(document).ready(function () {

  $(".devloperss").html("develop").addClass("devloper-msg");

});
$("video").bind("ended", function (e) {
  $(this).parents().find(".playpause_btn").find('.size-pause-video').hide();
  $(this).parents().find(".playpause_btn").find('.size-play-video').show();

});


// $(document).ready(function() {
//    $(this).parents(".main_result").find('.nores');
//   $("#next-show-results").css("display", "none");
//   });
	